import { React, useState, useEffect } from "react";
import "./EditAccountPopupStyle.css";
import LoadingButton from "../Loading button/LoadingButton";
import ToggleSwitch from "../RadioButton/ToggleSwitch";

function EditAccountPopup({ account, onPopup, message }) {
  let [responseGetAccount, setResponseGetAccount] = useState("");
  let [responseUpdateAccount, setResponseUpdateAccount] = useState("");
  let [accountData, setAccountData] = useState("");
  let [isResponseLoading, setIsResponseLoading] = useState(false);
  let [allowDistortedData, setAllowDistortedData] = useState(false);
  let [dataFormatMessage, setDataFormatMessage] = useState("");

  async function getAccount(account) {
    const hostname = window.location.hostname;
    try {
      const response = await fetch(
        `https://${hostname}/ConnectHub/AccountManagement/Account/${account.fipId}/${account.accountRefNo}`,
        { method: "GET" }
      );
      const data = await response.json();
      setResponseGetAccount(data.accountData);
      setAccountData(data.accountData);

      if(data.dataValid === false){
        setDataFormatMessage("Data is NOT in ReBIT format.");
      }
      else{
        setDataFormatMessage("Data is in ReBIT format.");
      }
    } catch (err) {
      setDataFormatMessage("Error fetching or parsing data.");
    }
  }

  async function updateAccount(account, accountData, skipValidation) {
    const hostname = window.location.hostname;
    try {
      const response = await fetch(
       `https://${hostname}/ConnectHub/AccountManagement/Account/${account.fipId}/${account.accountRefNo}?skipValidation=${skipValidation}`,
        {
          method: "PUT",
          body: accountData,
        }
      );

      const data = await response.text();
      setIsResponseLoading(false);
      setResponseUpdateAccount(data);

    } catch (error) {
      setDataFormatMessage("Error in updating account.");
    }
  }
  useEffect(() => {
    if (account) {
      getAccount(account);
    }
  }, [account]);

  const handleUpdateAccount = () => {
    setIsResponseLoading(true);
    updateAccount(account, accountData, allowDistortedData);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        backgroundColor: "rgba(0,0,0,0.6)",
      }}
      onClick={() => onPopup(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          background: "white",
          padding: "25px",
          borderRadius: "10px",
          maxHeight: "85%",
          maxWidth: "70%",
        }}
      >
        <h5 style={{ color: "black" }}>{message}</h5>
        <div style={{ overflow: "auto", flex: "1" }}>
          <textarea
            className="custom-textarea"
            autoComplete="off"
            defaultValue={responseGetAccount}
            style={{ padding: "10px" }}
            onChange={(e) => setAccountData(e.target.value)}
          />
        </div>
        <span style={{ fontSize: 14, color: "red" }}>
          Please provide the account data in XML format as per ReBIT specifications. If your data is in a different format, please enable the 'Allow Distorted Data' option to proceed.
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <ToggleSwitch
            isOn={allowDistortedData}
            handleToggle={() => setAllowDistortedData((prev) => !prev)}
          />
          <LoadingButton
            btnTitle="Save"
            isLoading={isResponseLoading}
            onClick={handleUpdateAccount}
          />
          <button type="submit" className="cancel-btn" onClick={() => onPopup(false)}>
            Cancel
          </button>
        </div>
        {responseUpdateAccount && (
          <span style={{ fontSize: 16, color: responseUpdateAccount.includes("success") ? "green" : "red" }}>
            {responseUpdateAccount}
          </span>
        )}
        {dataFormatMessage && (
          <span style={{ fontSize: 16, color: dataFormatMessage.includes("NOT") ? "red" : "green" }}>
            {dataFormatMessage}
          </span>
        )}
      </div>
    </div>
  );
}

export default EditAccountPopup;
